import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Company } from 'app/views/leadgen/model/Companies';
import { EsQueryResponse } from 'app/views/leadgen/model/EsQueryResponse';
import { QueryParameters, buildDslQuery } from 'app/views/leadgen/utils/EsDslQuery';

const baseUrl = `${process.env.LEAD_GENERATION_URL}${process.env.LEAD_GENERATION_PORT && process.env.LEAD_GENERATION_PORT !== '' ? `:${process.env.LEAD_GENERATION_PORT}` : ''}`;

const LEAD_GENERATION_INDEX = process.env.LEAD_GENERATION_INDEX;
const LEAD_GENERATION_SIZE = Number(process.env.LEAD_GENERATION_SIZE);
const USERNAME = process.env.ELASTIC_USERNAME;
const PASSWORD = process.env.ELASTIC_PASSWORD;

export const leadGenServiceApi = createApi({
  reducerPath: 'leadGenApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: headers => {
      const basicAuth = btoa(`${USERNAME}:${PASSWORD}`);
      headers.set('Authorization', `Basic ${basicAuth}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    searchCompanyById: builder.query<EsQueryResponse<Company>, { index?: string; id: string }>({
      query: args => `${args.index ?? LEAD_GENERATION_INDEX}/_doc/${args.id}`,
    }),
    searchCompaniesByQueryString: builder.query<EsQueryResponse<Company>, any>({
      query: args =>
        `${args.index ?? LEAD_GENERATION_INDEX}/_search?size=${args.size ?? LEAD_GENERATION_SIZE}${args.queryString ? '&q=' + args.queryString : ''}`,
    }),
    searchOrganizations: builder.query<EsQueryResponse<Company>, QueryParameters>({
      query: args => ({
        method: 'POST',
        url: `${args.index ?? LEAD_GENERATION_INDEX}/_search`,
        body: buildDslQuery(args),
      }),
    }),
    searchCompanies: builder.query<EsQueryResponse<Company>, QueryParameters>({
      query: args => ({
        method: 'POST',
        url: `${args.index ?? LEAD_GENERATION_INDEX}/_search?size=${args.size ?? LEAD_GENERATION_SIZE}${args.from ? `&from=${args.from}` : ''}`,
        ...(args.data ? { body: args.data } : {}),
      }),
    }),
  }),
});

export const {
  useSearchCompanyByIdQuery,
  useSearchOrganizationsQuery,
  useLazySearchOrganizationsQuery,
  useSearchCompaniesQuery,
} = leadGenServiceApi;
